"use client";

import type React from "react";
import { FieldContainer } from "./FieldContainer";
import { fieldErrorClassname, fieldInputVariants, fieldLabelClassname } from "./field-variants";
import { useFieldContext } from "../hooks/form-context";
import { useTranslations } from "next-intl";

export interface BaseFieldProps {
  label: string;
  placeholder?: string;
  required?: boolean;
  name: string;
}

export interface InputProps extends BaseFieldProps {
  type?: "text" | "email";
}

export const Input = ({ label, placeholder, required, name, type = "text" }: InputProps) => {
  const field = useFieldContext();
  const t = useTranslations("ClientKeys.contact_sales_page.form");

  return (
    <FieldContainer>
      <div className='tw-flex tw-justify-between'>
        <label className={fieldLabelClassname} htmlFor={name}>
          {label}
        </label>
        {!required && <span className='tw-text-[0.75rem] tw-text-black tw-opacity-40'>{t("labels.optional")}</span>}
      </div>
      <input
        className={fieldInputVariants()}
        type={type}
        id={name}
        name={name}
        placeholder={placeholder}
        required={required}
        value={field.state.value as string}
        onChange={e => field.handleChange(e.target.value)}
        onBlur={field.handleBlur}
        autoComplete='off'
      />
      {!field.state.meta.isValid && field.state.meta.isBlurred && field.state.meta.errors.length > 0 && (
        <div className={fieldErrorClassname} role='alert'>
          {field.state.meta.errors[0]}
        </div>
      )}
    </FieldContainer>
  );
};

export const FieldText = (props: Omit<InputProps, "type">) => {
  return <Input {...props} type='text' />;
};

export const FieldEmail = (props: Omit<InputProps, "type">) => {
  return <Input {...props} type='email' />;
};
